// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfiesTip_style_wrapper__L5PxZ","rotate":"SelfiesTip_style_rotate__XAejy"};